import { classNames } from "src/helpers/classNames";
import { useState, useEffect, useMemo } from "react";
import { CommentsInlineForm } from "./CommentsInlineForm";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { myTaskActionsHistoryListName } from "src/api/config/myTasksActions.config";
import { myTasks5WayCommentsListName } from "src/api/config/myTasks5Way.config";
import moment from "moment";
import DialogComponent, { DrawerComponent, Modal } from "src/components/DialogComponent";
import { AddButton } from "src/components/ui-icons/buttons";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { fieldType } from "src/types/form";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { uploadFile } from "src/api/requests/uploadFile";
import { updateFile } from "src/api/requests/updateFile";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import LoadingOpBg from "src/components/LoadingOpBg";
import _ from "lodash";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { Pencil, TrashIcon, Comment } from "src/components/ui-icons/card";
import { DownloadIcon, FileIcon } from "src/components/ui-icons/upload";
import TGButton from "src/components/ui/TGButton";
import { updateItem } from "src/modules/spItems/actions";
import { actionsStatus } from "src/api/config/systemSwitch";
import ImagesList from "src/components/ImagesList";
import EyeIcon from "src/components/ui-icons/reports/EyeIcon";
import axios from "axios";
import { siteUrl, strapiAdminUrl } from "src/api/config";
import { FileIconMobile } from "src/components/ui-icons/upload/FileIcon";
import { isPWA } from "src/utils/mobile";
import { downloadForApp } from "src/utils/downloadForApp";

type Props = {
    IDCard: any;
    zIndex: number;
    listComments: any;
    listFilesComments: any;
    field: string;
    history: boolean;
    customClass?: string;
    disabled?: boolean;
    onlyCurrentUser?: boolean;
    visiblePeriod?: {
        start?: string | Date | null;
        end?: string | Date | null;
    };
    strapiParams: { idFolder: string, apiStrapi: string, createElemInStrapi: boolean };
    variant?: 'default' | 'inline' | 'inlineAdd';
    label?: string;
    isRatingComment?: boolean;
    isMobile5WayCard?: boolean;
    isMobileIncCard?: boolean;
}

export default function Comments(props: Props) {

    const [comments, setComments] = useState<any>([]);
    const { IDCard, zIndex, listComments, listFilesComments, field, history, customClass, strapiParams, disabled = false, onlyCurrentUser = false, visiblePeriod, variant = 'default', label = 'Комментарии', isRatingComment, isMobile5WayCard = false, isMobileIncCard = false } = props;
    const [getComments, setGetComments] = useState(false);
    const [openAddCommentModal, setOpenAddCommentModal] = useState<boolean>(false);
    const [openRemoveCommentModal, setOpenRemoveCommentModal] = useState<boolean>(false);
    const [openRemoveFileCommentModal, setOpenRemoveFileCommentModal] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>(null);
    const [fieldForm, setFieldsForm] = useState<fieldType[]>([
        {
            type: 'textArea',
            key: 'TextComment',
            require: true,
            title: 'Комментарий',
            placeholder: 'Введите ваш комментарий',
            width: 'w-full'
        },
        {
            type: 'file',
            key: 'CommentFiles',
            multiple: true,
            require: false,
            width: 'w-full',
            title: 'Перетащите документ сюда или',
            titleFile: 'выберите файл',
            placeholder: 'Размер файла не более 50MB'
        }
    ])
    const [customLoading, setCustomLoading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const dispatch = useAppDispatch();
    const users: any = useAppSelector(selectUsers);
    const currentUser: any = useAppSelector(selectCurrentUser);
    const currentUserEmail = currentUser?.email?.toLowerCase().trim() || "";
    const [removeComment, setRemoveComment] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({});
    const [viewDocMode, setViewDocMode] = useState(false);
    const [imagesDoc, setImagesDoc] = useState<any>([]);
    const disabledFieldForm = useMemo(
        () => fieldForm.map((field) => ({ ...field, disabled })),
        [fieldForm, disabled]
    );
    const ratingCommentFlag = isRatingComment ?? (listComments === myTasks5WayCommentsListName ? false : undefined);

    const getLookupId = (lookup: any) => {
        if (!lookup) {
            return null;
        }
        if (lookup.get_lookupId) {
            return Number(lookup.get_lookupId());
        }
        return Number(lookup.ID || lookup.id || lookup);
    };

    const normalizeEmail = (email: any) => String(email || "").toLowerCase().trim();

    const getCommentAuthorEmail = (comment: any) => normalizeEmail(
        comment.Author?.get_email?.() ||
        comment.Author?.Email ||
        comment.Author?.email ||
        comment.Author?.User?.Email ||
        comment.Author?.User?.email ||
        comment.AuthorEmail
    );

    const getDateOnlyUtcMoment = (date: string | Date | null | undefined) => {
        if (!date) {
            return null;
        }

        const parsedDate = moment(date);
        if (!parsedDate.isValid()) {
            return null;
        }

        return moment.utc(parsedDate.format("YYYY-MM-DD"), "YYYY-MM-DD");
    };

    const getCommentVisiblePeriod = (comment: any) => getDateOnlyUtcMoment(comment.CreateCommentDate);

    const getCreateCommentDate = () => {
        const periodStart = getDateOnlyUtcMoment(visiblePeriod?.start);

        return periodStart?.startOf("day").toISOString();
    };

    useEffect(() => {
        if (imagesDoc.length > 0) {
            setViewDocMode(true);
        }
    }, [imagesDoc]);

    //Получение комментариев
    useEffect(() => {
        if (IDCard) {
            setCustomLoading(true);
            const ratingCommentFilter = ratingCommentFlag === false ? [false, null] : ratingCommentFlag;
            getItemsRequest({
                listName: listComments,
                filters: {
                    [field]: IDCard,
                    ...(ratingCommentFlag !== undefined
                        ? {
                            isRatingComment: ratingCommentFilter,
                        }
                        : {}),
                },
            }).then(results => {
                const tempComments = [...results.items].filter((comment: any) => {
                    if (onlyCurrentUser && getCommentAuthorEmail(comment) !== currentUserEmail) {
                        return false;
                    }

                    if (!visiblePeriod?.start || !visiblePeriod?.end) {
                        return true;
                    }

                    const commentVisiblePeriod = getCommentVisiblePeriod(comment);
                    const visiblePeriodStart = getDateOnlyUtcMoment(visiblePeriod.start);
                    const visiblePeriodEnd = getDateOnlyUtcMoment(visiblePeriod.end);
                    if (commentVisiblePeriod && visiblePeriodStart && visiblePeriodEnd) {
                        return (
                            commentVisiblePeriod.isValid() &&
                            commentVisiblePeriod.isBetween(
                                visiblePeriodStart.startOf("day"),
                                visiblePeriodEnd.endOf("day"),
                                undefined,
                                "[]"
                            )
                        );
                    }

                    return true;
                });
                const tempCommentsIDS = tempComments.map(comment => comment.ID);
                getItemsRequest({ listName: listFilesComments, filters: { Comment: tempCommentsIDS.length > 0 && tempCommentsIDS || null, ForHistory: false }, populateFields: ["Comment", "File"] }).then(results => {
                    const tempFilesComment = [...results.items];
                    let usersEmail: any = [];
                    // @ts-ignore
                    tempComments.forEach((item: any) => {
                        Object.keys(item).forEach((key) => {
                            const field = item[key];
                            if (field && !Array.isArray(field) && field.get_email) {
                                if (field.get_email()) {
                                    usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                                }
                            }
                            if (field && Array.isArray(field) && field.length > 0 && field[0].get_email) {
                                field.forEach((user) => {
                                    if (user.get_email()) {
                                        usersEmail = [...usersEmail, user.get_email().toLowerCase()];
                                    }
                                });
                            }
                        });
                    });
                    usersEmail = _.uniqWith(usersEmail, _.isEqual);
                    if (usersEmail.length > 0) {
                        let actualEmails: any = [];
                        usersEmail.forEach((item: string) => {
                            let check = false;
                            Object.keys(users).forEach((key) => {
                                if (key === item) {
                                    check = true;
                                }
                            });
                            if (!check) {
                                actualEmails = [...actualEmails, item.toLowerCase()];
                            }
                        });
                        if (actualEmails) {
                            dispatch(addUsers(actualEmails));
                        }
                    }
                    setComments([...tempComments.map(comment => {
                        return {
                            id: comment.ID,
                            textComment: comment.TextComment || "",
                            files: tempFilesComment.filter((file: any) => getLookupId(file.Comment) === comment.ID),
                            author: getCommentAuthorEmail(comment),
                            date: moment(comment.Created).format('DD.MM.YYYY HH:mm')
                        }
                    })])
                    setCustomLoading(false);
                });
            })
        }
    }, [getComments, IDCard, onlyCurrentUser, currentUserEmail, visiblePeriod?.start, visiblePeriod?.end, ratingCommentFlag]);

    useEffect(() => {
        console.log('comments: ', comments);
    }, [comments]);

    //Добавление/Обновление комментария к действию
    useEffect(() => {
        if (disabled) {
            return;
        }
        if (formData && Object.keys(formData).length > 0) {
            setCustomLoading(true);
            setOpenAddCommentModal(false);
            if (formData.ID) {
                const changesFieldValueLocal = localStorage.getItem('add_comment_data_form') || "{}";
                const changesFieldValue = JSON.parse(changesFieldValueLocal);
                localStorage.setItem('add_comment_data_form', "");

                updateItemRequest({
                    listName: listComments, body: {
                        TextComment: formData.TextComment,
                        ID: formData.ID,
                    }
                }).then((commentID: any) => {
                    let uploadCommentsFilesRequests: any = [];
                    formData.CommentFiles && formData.CommentFiles.length > 0 && formData.CommentFiles.filter((file: any) => !file.id && !file.ID).forEach((file: any) => {
                        uploadCommentsFilesRequests = [...uploadCommentsFilesRequests, uploadFile(file, listFilesComments, strapiParams.idFolder, strapiParams.apiStrapi, strapiParams.createElemInStrapi)]
                    });
                    if (uploadCommentsFilesRequests.length > 0) {
                        Promise.all(uploadCommentsFilesRequests).then((values: any) => {
                            let idsCommentFiles: number[] = [];
                            values.length > 0 && values.forEach((value: any) => {
                                idsCommentFiles = [...idsCommentFiles, value.id];
                                changesFieldValue['CommentFiles']['new'] = [...changesFieldValue['CommentFiles']['new'], { FileRef: value.path }];
                            });
                            if (idsCommentFiles.length > 0) {
                                let updateCommentFilesRequests: any = [];
                                idsCommentFiles.forEach((idFile: number) => {
                                    updateCommentFilesRequests = [...updateCommentFilesRequests, updateFile(listFilesComments, { Comment: commentID[0], ID: idFile }, strapiParams.apiStrapi, { Comment: commentID[0], id: idFile })]
                                });
                                if (updateCommentFilesRequests.length > 0) {
                                    Promise.all(updateCommentFilesRequests).then(() => {
                                        if (history) {
                                            const historyData = {
                                                Title: `History action card #${formData.ID}`,
                                                [field]: IDCard,
                                                History: JSON.stringify(changesFieldValue),
                                                Status: actionsStatus.editedComment, //Изменён комментарий
                                            }
                                            addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then(() => {
                                                setCustomLoading(false);
                                                setGetComments(!getComments);
                                            });
                                        } else {
                                            setCustomLoading(false);
                                            setGetComments(!getComments);
                                        }
                                    });
                                }
                            }
                        })
                    } else {
                        if (history) {
                            const historyData = {
                                Title: `History action card #${formData.ID}`,
                                [field]: IDCard,
                                History: JSON.stringify(changesFieldValue),
                                Status: actionsStatus.editedComment, //Изменён комментарий
                            }
                            addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then(() => {
                                setCustomLoading(false);
                                setGetComments(!getComments);
                            });
                        } else {
                            setCustomLoading(false);
                            setGetComments(!getComments);
                        }

                    }
                });
            } else {
                const createCommentDate = getCreateCommentDate();

                addItemRequest({
                    listName: listComments, body: {
                        Title: `Comment #${Math.floor(Math.random() * 1000)}`,
                        TextComment: formData.TextComment,
                        [field]: IDCard,
                        ...(ratingCommentFlag !== undefined
                            ? {
                                isRatingComment: ratingCommentFlag,
                            }
                            : {}),
                        ...(createCommentDate
                            ? {
                                CreateCommentDate: createCommentDate,
                            }
                            : {}),
                    }
                }).then((commentID: any) => {
                    let uploadCommentsFilesRequests: any = [];
                    formData.CommentFiles && formData.CommentFiles.length > 0 && formData.CommentFiles.forEach((file: any) => {
                        uploadCommentsFilesRequests = [...uploadCommentsFilesRequests, uploadFile(file, listFilesComments, strapiParams.idFolder, strapiParams.apiStrapi, strapiParams.createElemInStrapi)]
                    });
                    if (uploadCommentsFilesRequests.length > 0) {
                        let pathFiles: any = [];
                        Promise.all(uploadCommentsFilesRequests).then((values: any) => {
                            let idsCommentFiles: number[] = [];
                            values.length > 0 && values.forEach((value: any) => {
                                idsCommentFiles = [...idsCommentFiles, value.id];
                                pathFiles = [...pathFiles, { FileRef: value.path }];
                            });
                            if (idsCommentFiles.length > 0) {
                                let updateCommentFilesRequests: any = [];
                                idsCommentFiles.forEach((idFile: number) => {
                                    updateCommentFilesRequests = [...updateCommentFilesRequests, updateFile(listFilesComments, { Comment: commentID, ID: idFile }, strapiParams.apiStrapi, { Comment: commentID, id: idFile })]
                                });
                                if (updateCommentFilesRequests.length > 0) {
                                    Promise.all(updateCommentFilesRequests).then(() => {
                                        if (history) {
                                            const historyData = {
                                                Title: `History comment action card #${commentID}`,
                                                [field]: IDCard,
                                                History: JSON.stringify({
                                                    TextComment: { new: formData.TextComment, old: "" },
                                                    CommentFiles: { new: pathFiles, old: [] },
                                                    Created: { new: moment().format('DD.MM.YYYY HH:mm'), old: "" }
                                                }),
                                                Status: actionsStatus.addComment, //Добавлен комментарий
                                            }
                                            addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then(() => {
                                                setCustomLoading(false);
                                                setGetComments(!getComments);
                                            }).catch(() => {
                                                setCustomLoading(false);
                                                setGetComments(!getComments);
                                            });
                                        } else {
                                            setCustomLoading(false);
                                            setGetComments(!getComments);
                                        }
                                    }).catch(() => {
                                        setCustomLoading(false);
                                        setGetComments(!getComments);
                                    });
                                } else {
                                    setCustomLoading(false);
                                    setGetComments(!getComments);
                                }
                            } else {
                                setCustomLoading(false);
                                setGetComments(!getComments);
                            }
                        }).catch(() => {
                            setCustomLoading(false);
                            setGetComments(!getComments);
                        });
                    } else {
                        if (history) {
                            const historyData = {
                                Title: `History comment action card #${commentID}`,
                                [field]: IDCard,
                                History: JSON.stringify({
                                    TextComment: { new: formData.TextComment, old: "" },
                                    Created: { new: moment().format('DD.MM.YYYY HH:mm'), old: "" }
                                }),
                                Status: actionsStatus.addComment, //Добавлен комментарий
                            }
                            addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then(() => {
                                setCustomLoading(false);
                                setGetComments(!getComments);
                            });
                        } else {
                            setCustomLoading(false);
                            setGetComments(!getComments);
                        }
                    }
                });
            }
        }
    }, [formData]);

    //Удаление комментария
    const removeCommentHandle = () => {
        if (disabled) {
            return;
        }
        if (removeComment) {
            setCustomLoading(true);
            setOpenRemoveCommentModal(false);
            let removeCommentRequests: any = [
                deleteItemRequest({ listName: listComments, ID: removeComment.id })
            ]
            getItemsRequest({ listName: listFilesComments, filters: { Comment: removeComment.id } }).then(results => {
                const tempFilesComment = [...results.items];
                let filesCommentIDS: { ID: number }[] = [];
                if (tempFilesComment.length > 0) {
                    tempFilesComment.forEach((file: any) => {
                        filesCommentIDS = [...filesCommentIDS, { ID: Number(file.ID) }];
                    });
                }
                if (filesCommentIDS.length > 0) {
                    removeCommentRequests = [...removeCommentRequests, deleteItemRequest({ listName: listFilesComments, Ids: filesCommentIDS, ID: 0, fileField: 'File' })]
                }
                Promise.all(removeCommentRequests).then(() => {
                    if (history) {
                        const historyData = {
                            Title: `History comment action card #${removeComment.id}`,
                            [field]: IDCard,
                            History: JSON.stringify({
                                TextComment: { new: "", old: removeComment.textComment },
                                CommentFiles: { new: [], old: removeComment.files },
                                Created: { new: "", old: removeComment.date }
                            }),
                            Status: actionsStatus.deleteComment, //Удалён комментарий
                        }
                        addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then(() => {
                            setCustomLoading(false);
                            setRemoveComment(null);
                            setGetComments(!getComments);
                        });
                    } else {
                        setCustomLoading(false);
                        setRemoveComment(null);
                        setGetComments(!getComments);
                    }
                });
            });
        }
    }

    //Редактирование комментария
    const editCommentHanle = (comment: any) => {
        if (disabled) {
            return;
        }
        let tempDefaultValues: any = {};
        if (comment.files.length > 0) {
            tempDefaultValues['CommentFiles'] = comment.files;
        }
        tempDefaultValues['TextComment'] = comment.textComment;
        tempDefaultValues['ID'] = comment.id;
        setDefaultValues((prevState: any) => {
            return { ...tempDefaultValues }
        });
    }

    useEffect(() => {
        if (Object.keys(defaultValues).length > 0) {
            setOpenAddCommentModal(true);
        }
    }, [defaultValues]);

    //Удаление файла у комментария
    const removeCommentFileHandle = () => {
        if (disabled) {
            return;
        }
        const idRemoveFile = localStorage.getItem('removeCommentFileInActionCard');
        localStorage.setItem('removeCommentFileInActionCard', "");
        setOpenRemoveFileCommentModal(false);
        dispatch(updateItem({ listName: listFilesComments, body: { ID: idRemoveFile, ForHistory: true } }));
    }

    useEffect(() => {
        if (!openAddCommentModal) {
            setDefaultValues({});
        }
    }, [openAddCommentModal])

    useEffect(() => {
        if (disabled) {
            setOpenAddCommentModal(false);
            setOpenRemoveCommentModal(false);
            setOpenRemoveFileCommentModal(false);
        }
    }, [disabled]);

    return (
        <FlexCol className={customClass}>
            {variant !== 'default'
                ? <CommentsInlineForm
                    label={label}
                    variant={variant}
                    disabled={disabled}
                    loading={customLoading}
                    comments={comments}
                    currentUserEmail={currentUserEmail}
                    users={users}
                    onSave={(data) => setFormData(data)}
                    onEditComment={editCommentHanle}
                    onRemoveComment={(comment) => {
                        setRemoveComment(comment);
                        setOpenRemoveCommentModal(true);
                    }}
                    setImagesDoc={setImagesDoc}
                    setPreviewLoading={setPreviewLoading}
                    previewLoading={previewLoading}
                />
                : <>
                    <FlexCol className="relative gap-5">
                        <h3 className='text-[#637381] font-medium hidden sm:block'>Комментарии и вложения  · {comments.length}</h3>
                        {customLoading && <LoadingOpBg customWrapperClass="z-20" />}
                        {comments.map((comment: any) => (
                            <div key={comment.id} className="flex p-[16px] sm:p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-full rounded-lg border border-solid border-[#DFE4EA]">
                                <FlexRow className="justify-between w-full">
                                    <div className="flex gap-2 items-center">
                                        <UserAvatar
                                            avatar={users[comment.author] && users[comment.author].avatar}
                                            shortName={users[comment.author] && users[comment.author].displayName && users[comment.author].displayName.split(' ')[0][0] + users[comment.author].displayName.split(' ')[1][0]}
                                            displayName={users[comment.author] && users[comment.author].displayName}
                                            email={comment.author}
                                        />
                                        <div className="flex flex-col justify-center items-start">
                                            <span className="text-[13px] sm:text-sm text-[#111928] hidden sm:block">{users[comment.author] && users[comment.author].displayName}</span>
                                            <span className="text-[13px] sm:text-sm text-[#111928] sm:hidden">{users[comment.author] && users[comment.author].displayName.replace(/\s*\(.*?\)\s*/g, '')}</span>
                                            <span className="text-[12px] sm:text-sm text-[#637381]">{comment.date}</span>
                                        </div>
                                    </div>
                                    {currentUser.email === comment.author && !disabled &&
                                        <FlexRow className="gap-2 hover:cursor-pointer">
                                            <div onClick={() => editCommentHanle(comment)}>
                                                <Pencil hover={true} />
                                            </div>
                                            <div onClick={() => {
                                                setRemoveComment(comment);
                                                setOpenRemoveCommentModal(true);
                                            }}>
                                                <TrashIcon />
                                            </div>
                                        </FlexRow>
                                    }
                                </FlexRow>
                                <div className="flex gap-2">
                                    <Comment classNames="hidden sm:block"/>
                                    <span className="text-sm text-[#111928] whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: comment.textComment && comment.textComment.replace(/(^|\W)(#[а-я\w][а-я\w-]*)/gi, '<span style="color: rgb(0,98,155)">$&</span>') || '' }} />
                                </div>
                                {comment.files.length > 0 && comment.files.map((file: any) => (
                                    <>
                                        {(file.FileLeafRef.indexOf('.jpg') !== -1 || file.FileLeafRef.indexOf('.jpeg') !== -1 || file.FileLeafRef.indexOf('.gif') !== -1 || file.FileLeafRef.indexOf('.png') !== -1) &&
                                            <a
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setImagesDoc([file.FileRef]);
                                                }}
                                                href='#'
                                                key={file.ID}
                                                className="box-border flex relative z-10 flex-row gap-3 justify-between px-4 py-2 w-full rounded-lg cursor-pointer upload bg-sp-gray"
                                            >
                                                <div className="flex flex-col grow">
                                                    <div className="flex flex-row gap-x-2.5">
                                                        <div className="hidden sm:flex flex-col items-center justify-center">
                                                            <FileIcon />
                                                        </div>
                                                        <span className="flex sm:hidden">
                                                            <FileIconMobile />
                                                        </span>
                                                        <div className="flex flex-col text-[14px] truncate sm:overflow-visible sm:whitespace-normal sm:text-ellipsis w-[140px] sm:w-full">{file.FileLeafRef}</div>
                                                    </div>
                                                </div>
                                                <div className="flex relative z-10 flex-row">
                                                    <span className="inline-block">
                                                        <EyeIcon />
                                                    </span>

                                                    <a onClick={async (e) => {
                                                            e.stopPropagation();

                                                            if (isPWA()) return;

                                                            e.preventDefault();
                                                            await downloadForApp(file);
                                                        }}
                                                        download={true} className="flex relative z-10 flex-row ml-2">
                                                        <span className="inline-block">
                                                            <DownloadIcon />
                                                        </span>
                                                    </a>

                                                </div>
                                            </a>
                                            || (file.FileLeafRef.indexOf('.docx') !== -1 || file.FileLeafRef.indexOf('.xlsx') !== -1) &&
                                            <>
                                                <a
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setPreviewLoading(true);
                                                        axios.post(`${siteUrl}/api/md-documents-files/preview_path`, {
                                                            id: file.ID,
                                                            path: file.FileRef.replace(siteUrl, strapiAdminUrl),
                                                        }, { withCredentials: true }).then(results => {
                                                            const { data } = results;
                                                            setImagesDoc(data.map((url: string) => `${siteUrl}${url}`));
                                                            setPreviewLoading(false);
                                                        });
                                                    }}
                                                    href='#'
                                                    key={file.ID}
                                                    className="box-border flex relative z-10 flex-row gap-3 justify-between px-4 py-2 w-full rounded-lg cursor-pointer upload bg-sp-gray"
                                                >
                                                    <div className="flex flex-col grow">
                                                        <div className="flex flex-row gap-x-2.5">
                                                            <div className="flex flex-col justify-center items-center">
                                                                <FileIcon />
                                                            </div>
                                                            <div className="flex flex-col">{file.FileLeafRef}</div>
                                                        </div>
                                                    </div>
                                                    <div className="flex relative z-10 flex-row">
                                                        <span className="inline-block mr-[10px] mt-[3px]">
                                                            {previewLoading &&
                                                                <FlexCol className="flex w-6 h-6">
                                                                    <Loading />
                                                                </FlexCol> ||
                                                                <EyeIcon />
                                                            }
                                                        </span>

                                                        <a onClick={async (e) => {
                                                            e.stopPropagation();

                                                            if (isPWA()) return;

                                                            e.preventDefault();
                                                            await downloadForApp(file);
                                                        }}
                                                            download={true} className="flex relative z-10 flex-row ml-2">
                                                            <span className="inline-block">
                                                                <DownloadIcon />
                                                            </span>
                                                        </a>
                                                    </div>
                                                </a>
                                            </>
                                        }
                                    </>
                                ))}
                            </div>
                        ))}
                    </FlexCol>
                    <button type="button" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        if (disabled) {
                            return;
                        }
                        setOpenAddCommentModal(true);
                    }} className={classNames("btn-white w-full flex justify-center items-center py-3 mt-5 rounded-md leading-[22px] shadow-custom text-[#00629B]", disabled ? "cursor-not-allowed opacity-60" : "")}>
                        <div className="mr-1.5"><AddButton /></div>
                        <span className="w-[70%] sm:w-full">Добавить комментарий и вложение</span>
                    </button>
                </>
            }
            {/*Модалка для добавления комментария к действию */}
            <Modal
                zIndex={zIndex ? zIndex + 10 : 70}
                modalClassName="min-h-px p-[24px] sm:p-10"
                open={openAddCommentModal}
                toggleDialog={setOpenAddCommentModal}
            >
                <div className="max-w-[600px]">
                    <header className="pb-4">
                        {Object.keys(defaultValues).length > 0 &&
                            <h2 className="text-[16px] sm:text-[24px]">Редактирование комментария</h2> ||
                            <h2 className="text-[16px] sm:text-[24px]">Добавление комментария</h2>
                        }
                    </header>
                    <Form setImagesDoc={setImagesDoc} listUploadFiles={listFilesComments} type="add_comment" setFormData={setFormData} fieldsForm={disabledFieldForm} defaultValues={defaultValues} setOpenCancelAddCard={setOpenAddCommentModal} openCancelAddCard={openAddCommentModal} setOpenRemoveFileCommentModal={setOpenRemoveFileCommentModal} openRemoveFileCommentModal={openRemoveFileCommentModal} isMobile5WayCard={isMobile5WayCard} isMobileIncCard={isMobileIncCard} />
                </div>
            </Modal>
            {/*Модалка удаления комментария */}
            <Modal
                zIndex={zIndex ? zIndex + 10 : 70}
                modalClassName="min-h-px flex gap-5 p-10"
                open={openRemoveCommentModal}
                toggleDialog={setOpenRemoveCommentModal}
            >
                <h2>Подтвердите действие</h2>

                <p>Вы уверены, что хотите удалить комментарий?</p>
                <div className="w-full border-t" />
                <footer className="flex justify-between w-full">
                    <TGButton type="button" color="white" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        setOpenRemoveCommentModal(!openRemoveCommentModal)
                    }}>
                        Отмена
                    </TGButton>
                    <TGButton type="button" color="bluedark" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        removeCommentHandle();
                    }}>
                        Удалить комментарий
                    </TGButton>
                </footer>
            </Modal>
            {/*Модалка удаления файла у комментария */}
            <Modal
                zIndex={zIndex ? zIndex + 20 : 70}
                modalClassName="min-h-px flex gap-5 p-10"
                open={openRemoveFileCommentModal}
                toggleDialog={setOpenRemoveFileCommentModal}
            >
                <h2>Подтвердите действие</h2>

                <p>Вы уверены, что хотите удалить этот файл?</p>
                <div className="w-full border-t" />
                <footer className="flex justify-between w-full">
                    <TGButton type="button" color="white" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        setOpenRemoveFileCommentModal(!openRemoveFileCommentModal)
                    }}>
                        Отмена
                    </TGButton>
                    <TGButton type="button" color="bluedark" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        removeCommentFileHandle();
                    }}>
                        Удалить файл
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 40 : 70}
                modalClassName="min-h-px flex gap-5 p-10"
                open={viewDocMode}
                toggleDialog={setViewDocMode}
            >
                <ImagesList
                    images={imagesDoc}
                />
                <FlexRow className="justify-center items-center w-full">
                    <TGButton onClick={() => {
                        setImagesDoc([]);
                        setViewDocMode(false);
                    }} color="bluedark">
                        Закрыть
                    </TGButton>
                </FlexRow>
            </Modal>
        </FlexCol>
    )
}
